// Fleet's page: what runs in the fleet, as one inventory read from any kind
// (FleetOverview). A reader without session analytics keeps the evidence page
// Fleet had (FleetPage), which reads installed software and endpoints alone.
import FleetOverview from "../components/FleetOverview.jsx";
import { DEFAULT_RANGE } from "../lib/dateRangePresets.js";
import { fleetConsoleAvailable } from "../lib/fleetConsoleStore.js";
import { useMyPermissions } from "../lib/permissions.js";
import FleetPage from "./FleetPage.jsx";

// The page reads the app's range, as the Overview and Findings do.
export default function FleetHome({ range = DEFAULT_RANGE }) {
  const caps = useMyPermissions();
  return fleetConsoleAvailable(caps) ? <FleetOverview range={range} /> : <FleetPage range={range} />;
}
